import React from 'react';
import styles from './ReportHeader.module.scss';
import { SFButton } from 'sfui';
import { Customer } from 'ui-smartforce-settings';
import { getStringAbbreviation, isReportEditable } from '../../../../Helpers';
import { Divider } from '../../../Divider/Divider';
import { AmendDisabledTooltip } from '../../../AmendDisabledTooltip/AmendDisabledTooltip';

export interface ReportHeaderProps {
  customer: Customer;
  canAmend: boolean;
  reportStatus?: string;
  onAmend: () => void;
}

export const ReportHeader = ({
  customer,
  canAmend,
  reportStatus,
  onAmend
}: ReportHeaderProps): React.ReactElement<ReportHeaderProps> => {
  const onAmendClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onAmend();
  };

  const isAmendButtonDisabled: boolean = !(
    canAmend && isReportEditable(reportStatus)
  );

  return (
    <div className={styles.reportHeader}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logo}>
            {customer.badge && (
              <img className={styles.badge} src={customer.badge} alt="" />
            )}
            {!customer.badge && (
              <p className={styles.abbreviation}>
                {getStringAbbreviation(customer.full_name as string)}
              </p>
            )}
          </div>
          <div className={styles.text}>
            <h5>{customer.full_name}</h5>
            <p>{customer.state_name}</p>
          </div>
        </div>

        <AmendDisabledTooltip
          cause={!canAmend ? 'no-permission' : 'archived'}
          isActive={isAmendButtonDisabled}
        >
          <SFButton
            disabled={isAmendButtonDisabled}
            size="small"
            variant="outlined"
            onClick={onAmendClick}
          >
            Amend Report
          </SFButton>
        </AmendDisabledTooltip>
      </div>

      <Divider size={2} />
    </div>
  );
};
